import { isPlatformBrowser } from "@angular/common";
import { EventEmitter, Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { makeStateKey, TransferState } from "@angular/platform-browser";
import { SplitPaymentData, SplitPaymentDetails } from "app/shared/model/splitPaymentDetails";

import { BehaviorSubject } from "rxjs";

import { ApiEndpoints } from "../shared/apiEndpoints";
import { PitchData } from "../shared/model/pitch";
import { Slot } from "../shared/model/slot";
import { VenueData } from "../shared/model/venue";

const PITCHDATA = makeStateKey("pitchData");
const VENUEDATA = makeStateKey("venueData");
const SPLITVENUEDATA = makeStateKey("splitVenueData");

@Injectable()
export class VenueService {
    pitchData: PitchData;
    venueData: VenueData;
    splitVenueData: SplitPaymentDetails;
    slot: Slot;

    slotSubject = new BehaviorSubject<undefined | Slot>(undefined);
    pitchSubject = new BehaviorSubject<undefined | PitchData>(undefined);
    splitVenueSubject = new BehaviorSubject<undefined | SplitPaymentDetails>(undefined);

    pitchDataChange = new EventEmitter();
    venueDataChange = new EventEmitter();
    splitVenueDataChange = new EventEmitter();

    private isBrowser: boolean = isPlatformBrowser(this.platformId);

    constructor(
        private apiEndpoints: ApiEndpoints,
        private transferState: TransferState,
        @Inject(PLATFORM_ID) private platformId
    ) {
        if (this.isBrowser) {
            const pitchData = this.transferState.get(PITCHDATA, undefined) as any;
            const venueData = this.transferState.get(VENUEDATA, undefined) as any;
            const splitVenueData = this.transferState.get(SPLITVENUEDATA, undefined) as any;

            if (pitchData && venueData) {
                const pitchDataObject = pitchData;
                const venueDataObject = venueData;

                this.pitchData = pitchDataObject;
                this.pitchDataChange.emit(pitchDataObject);

                this.venueData = venueDataObject;
                this.venueDataChange.emit(venueDataObject);
            }
            if(splitVenueData) {
                this.splitVenueData = splitVenueData;
                this.splitVenueDataChange.emit(splitVenueData)
            }
        }
    }

    updatePitch(pitchId: number): void {
        this.apiEndpoints
            .callMlpApiPitch(pitchId)
            .subscribe((pitchData: PitchData) => {
                this.pitchData = pitchData;
                this.pitchDataChange.emit(pitchData);
            });
    }

    updateVenue(venueId: number): void {
        this.apiEndpoints
            .callMlpApiVenue(venueId)
            .subscribe((data: VenueData) => {
                this.venueData = data;
                this.venueDataChange.emit(data);
            });
    }
}
